import React, { useState } from 'react';
import Image from 'next/image';

interface JeuJuliaProps {
	onComplete: (score: number) => void;
}

interface Question {
	question: string;
	image: string;
	answerText: string[];
	type: 'text';
}

const questions: Question[] = [
	{
		question: "Trouve le nom exacte de ce logo ?",
		image: "/img/logo1.png",
		answerText: ["le bon marche", "le bon marché", "BM", "bm", "le BM", "bon marche", "bon marché"],
		type: 'text',
	},
	{
		question: "Trouve le nom exacte de ce logo ?",
		image: "/img/logo2.png",
		answerText: ["Aperol", "Apérol", "aperol", "apérol"],
		type: 'text',
	},
];

const JeuJulia: React.FC<JeuJuliaProps> = ({ onComplete }) => {
	const [step, setStep] = useState(0);
	const [score, setScore] = useState(0);
	const [textInput, setTextInput] = useState("");
	const [textAnswered, setTextAnswered] = useState(false);
	const [textCorrect, setTextCorrect] = useState<boolean | null>(null);

	const handleTextSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		const userAnswer = textInput.trim().toLowerCase();
		const correctAnswers = questions[step].answerText;

		// Vérifier si la réponse utilisateur correspond à une des bonnes réponses
		const correct = correctAnswers.some(answer =>
			answer.toLowerCase() === userAnswer
		);

		setTextCorrect(correct);
		setTextAnswered(true);
		if (correct) setScore(s => s + 1);

		setTimeout(() => {
			setTextAnswered(false);
			setTextInput("");
			setTextCorrect(null);
			if (step < questions.length - 1) {
				setStep(s => s + 1);
			} else {
				onComplete(score + (correct ? 1 : 0)); // Correction du score final
			}
		}, 1200);
	};

	return (
		<div className="card bg-gradient-to-br from-gray-50 to-gray-200 border-gray-300 p-8 rounded-xl shadow-lg text-center">
			<div className="mb-4 flex justify-center">
				<Image src={questions[step].image} alt="illustration" width={120} height={120} className="rounded-lg object-contain" />
			</div>
			<div className="mb-4 text-lg font-semibold text-bordeaux-700">{questions[step].question}</div>
			<form onSubmit={handleTextSubmit} className="mb-4 flex flex-col items-center gap-3">
				<input
					type="text"
					value={textInput}
					onChange={e => setTextInput(e.target.value)}
					className="input-field w-full max-w-xs"
					placeholder="Ta réponse..."
					disabled={textAnswered}
					autoFocus
				/>
				<button
					type="submit"
					className="btn-primary px-6 py-2"
					disabled={textAnswered || textInput.trim() === ""}
				>
					Valider
				</button>
			</form>
			{textAnswered && (
				<div className={`mt-2 font-bold ${textCorrect ? 'text-green-700' : 'text-red-700'}`}>
					{textCorrect ? 'Bonne réponse !' : `Mauvaise réponse. Les bonnes réponses étaient : ${questions[step].answerText.join(', ')}`}
				</div>
			)}
			<div className="text-bordeaux-600 text-sm mb-2">Question {step + 1} / {questions.length}</div>
			{step === questions.length - 1 && textAnswered && (
				<div className="mt-2 text-bordeaux-700 font-bold">Score : {score + (textCorrect ? 1 : 0)} / {questions.length}</div>
			)}
		</div>
	);
};

export default JeuJulia;
